import { t } from 'i18next';
import React from 'react';

export default function ThankYouPage() {

    return (<div className="kt-body">
        <div className="kt-panel" >
            <div className="kt-panel-content" >
                <h1>{t("pages.thankYouPage.thankYou")}</h1>
                <h2>{t("pages.thankYouPage.weAreLookingForward")}</h2>
            </div>
        </div>
    </div>);

}